import React from "react";
import styles from "./headerLogo.module.scss";
import { Link } from "react-router-dom";
import useGetInstitutionLogo from "@common/hooks/useGetInstitutionLogo";

interface HeaderLogoProps {
  urlHome: string;
}

const HeaderLogo = ({ urlHome }: HeaderLogoProps) => {
  const { logo, name } = useGetInstitutionLogo();

  return (
    <Link to={urlHome} className={styles.headerLogo}>
      <img className={styles.headerLogo_img} src={logo} alt={name} loading="lazy" />
    </Link>
  );
};

export default HeaderLogo;
